import { useEffect } from 'react';

import { useUserQuery } from 'features/user/useUserQuery';
import DataExtractionService from 'services/dataExtraction/DataExtractionService';

import { useAppState } from '../AppStateProvider';
import { EmptyStateView } from '../components/EmptyStateView';
import { Header } from '../components/Header';
import { LoadingView } from '../components/LoadingView';
import { useCompaniesQuery } from '../features/company/useCompaniesQuery';
import { useDisabledPageView } from '../hooks/useDisabledPageView';

import { isCompanyDataPresent } from './company-overview/MultipleDomainsContainer/utils';
import { CompanyPage } from './CompanyPage';
import { StyledMeetingNoCompanyEmptyStateView } from './styles';

export const MeetingPage = () => {
  const userQuery = useUserQuery();
  const companiesQuery = useCompaniesQuery();
  const { collectedMeeting } = useAppState();

  const isCompaniesDataPresent = Boolean(
    companiesQuery?.data?.length && companiesQuery?.data.some((company) => isCompanyDataPresent(company))
  );

  useEffect(() => {
    if (!isCompaniesDataPresent || !companiesQuery?.data || companiesQuery.data.length === 0) {
      return;
    }

    const userDomain = DataExtractionService.meeting.extractDomainFromEmail(userQuery.data?.email || '');

    const companyNames: Record<string, string> = {};

    companiesQuery.data.forEach((company) => {
      if (company.domain && userDomain !== company.domain) {
        companyNames[company.domain] = company.name;
      }
    });

    window.parent.postMessage({ message: 'meeting companies', companyNames }, '*');
  }, [companiesQuery?.data, isCompaniesDataPresent, userQuery.data?.email]);

  const { isDisabledPageVisible, disabledPageView } = useDisabledPageView();

  if (isDisabledPageVisible) {
    return disabledPageView;
  }

  if (!collectedMeeting || collectedMeeting?.domains.length === 0) {
    return (
      <>
        <Header />
        <EmptyStateView
          textKey="meeting.empty_state.text"
          messageKey="meeting.empty_state.message"
          img="/images/empty-state-girl-calendar.svg"
          variant="girl-calendar"
        />
      </>
    );
  }

  if (companiesQuery.isLoading) {
    return (
      <>
        <Header />
        <LoadingView />
      </>
    );
  }

  if (collectedMeeting && !isCompaniesDataPresent) {
    return (
      <>
        <Header />
        <StyledMeetingNoCompanyEmptyStateView
          textKey="meeting.empty_state.no_company.text"
          messageKey="meeting.empty_state.no_company.message"
          img="/images/empty-state-lens.svg"
          variant="lens-rised"
          data-automation="NoCompanyEmptyState"
        />
      </>
    );
  }

  return <CompanyPage />;
};
